export default __webpack_public_path__ + "static/media/android-launchericon-512-512.f0a8ef34.png";